define('modules/editor/views/property_boxes/video_content',['require','exports','module','./base','ldsh!../../templates/property_boxes/video_content'],function(require, exports, module){
  "use strict";
  var BasePropertyBox = require("./base");
  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/video_content"),
    events: {
      "click .js-edit": "requestContent"
    },
    requestContent: function(e){
      e.preventDefault();
      this.model.parent.editVideoContent();
    }
  });
});
